import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['CheckboxesGroupStyles-cvaRoot', '']);

export const cvaSearch = cva(['CheckboxesGroupStyles-cvaSearch', 'relative', 'mb-2.4']);

export const cvaSearchInput = cva([
  'CheckboxesGroupStyles-cvaSearchInput',
  'block',
  'w-full h-4.8',
  'py-1.2 px-2.4',
  'bg-cLightGrey',
  'rounded-[1.6rem]',
  'border-none outline-none',
  'text-bodyM placeholder:text-cBlack placeholder:text-opacity-[0.32]',
  'focus:placeholder:opacity-0',
]);

export const cvaSearchIcon = cva([
  'CheckboxesGroupStyles-cvaSearchIcon',
  'absolute z-[1] right-2.4 top-1/2 -translate-y-1/2',
  'w-2.4 h-2.4',
  'pointer-events-none',
]);

export const cvaItems = cva(['CheckboxesGroupStyles-cvaItems', 'not-last:mb-2.4', ''], {
  variants: {
    scroll: {
      true: ['sm:overflow-auto sm:max-h-[36.4rem]'],
      false: [],
    },
  },
  defaultVariants: {
    scroll: false,
  },
});

export const cvaShowMore = cva([
  'CheckboxesGroupStyles-cvaShowMore',
  'inline-flex gap-0.2 items-center',
  'cursor-pointer select-none',
]);

export const cvaShowMoreText = cva([
  'CheckboxesGroupStyles-cvaShowMoreText',
  'text-bodyM font-semibold',
  'border-b-[0.1rem] border-cBlack64 border-dashed',
]);

export const cvaShowMoreIcon = cva(
  ['CheckboxesGroupStyles-cvaShowMoreIcon', 'w-1.6 h-1.6', 'stroke-cBlack', 'transition-transform duration-300'],
  {
    variants: {
      active: {
        true: ['-rotate-180'],
        false: [''],
      },
    },
    defaultVariants: {
      active: false,
    },
  }
);

export const cvaGroups = cva([
  'CheckboxesGroupStyles-cvaGroups',
  'sm:overflow-auto',
  'not-last:mb-2.4',
  'sm:max-h-[36.4rem]',
]);

export const cvaGroup = cva(['CheckboxesGroupStyles-cvaGroup', 'not-last:mb-3.2']);

export const cvaGroupTitle = cva(['CheckboxesGroupStyles-cvaGroupTitle', 'mb-1.6', 'text-h4 font-secondary']);
